import { DismantlingBayType } from "../models/DismantlingBay";
import { IProductionDashboardBay, ProductionDashboardView } from "../models/ProductionDashboard";

/**
 * The Line/Bays toggle the Production Dashboard persists. Shared because anything that wants to
 * show the same figures as that dashboard has to ask the overview endpoint for the same bay type —
 * the payload only ever contains bays of one type, so a mismatch here silently counts nothing.
 */
export const PRODUCTION_VIEW_STORAGE_KEY = "productionDashboard.view";

export function readStoredProductionView(): ProductionDashboardView {
  if (typeof window === "undefined") return "Line";
  const value = window.localStorage.getItem(PRODUCTION_VIEW_STORAGE_KEY);
  return value === "Bays" ? "Bays" : "Line";
}

export function bayTypeForProductionView(view: ProductionDashboardView): DismantlingBayType {
  return view === "Line" ? DismantlingBayType.ProductionLine : DismantlingBayType.Bay;
}

/**
 * Everything the planner put on a line for today: started (current) plus still to come (due
 * next). The API builds both from today's allocations and keeps them disjoint. Shared by the
 * Planned | Actual card and the TV view's headline tile so the two always agree.
 */
export function plannedTodayCount(bays: IProductionDashboardBay[]): number {
  return bays.reduce(
    (n, bay) => n + (bay.currentVehicles?.length ?? 0) + (bay.dueNext?.length ?? 0),
    0
  );
}
